import React from 'react'
import { FormattedDate } from 'react-intl'

export function LastModifiedCell({
  rowData: { modified }
}: {
  readonly rowData: {
    readonly modified: string
  }
}) {
  return (
    <div>
      <FormattedDate
        value={modified}
        {...{
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }}
      />
    </div>
  )
}
